import request from "../bigDataApi";
/* 作业统计-接口 */
//区域作业发布数/区
export function homeworkbase(data) {
    return request({
        url:'/assbe/statistical/institutions/homeworkbase',
        method: "post",
        data,
    });
}

//区域作业反馈数/区
export function feedbackbase(data) {
    return request({
        url:'/assbe/statistical/institutions/feedbackbase',
        method: "post",
        data,
    });
}

//区域作业备案数量/区
export function homeworkrecord(data) {
    return request({
        url:'/assbe/statistical/institutions/homeworkrecord',
        method: "post",
        data,
    });
}

//区域作业反馈完成平均时长列表/区
export function homeworkfeedback(data) {
    return request({
        url:'/assbe/statistical/institutions/homeworkfeedback',
        method: "post",
        data,
    });
}

//机构统计作业数量/区
export function implementationinfo(data) {
    return request({
        url:'/assbe/statistical/institutions/implementationinfo',
        method: "post",
        data,
    });
}


//市级作业发布数/市
export function cityHomeworkbase(data) {
    return request({
        url:'/assbe/statistical/city/homeworkbase',
        method: "post",
        data,
    });
}

//市级作业反馈数/市
export function cityFeedbackbase(data) {
    return request({
        url:'/assbe/statistical/city/feedbackbase',
        method: "post",
        data,
    });
}

//市级作业备案数量/市
export function cityHomeworkrecord(data) {
    return request({
        url:'/assbe/statistical/city/homeworkrecord',
        method: "post",
        data,
    });
}

//区域作业反馈完成平均时长列表/市
export function cityHomeworkfeedback(data) {
    return request({
        url:'/assbe/statistical/city/homeworkfeedback',
        method: "post",
        data,
    });
}

//区域统计作业数量/市
export function cityImplementationinfo(data) {
    return request({
        url:'/assbe/statistical/city/implementationinfo',
        method: "post",
        data,
    });
}